module.exports = __webpack_public_path__ + "img/goodsPresale.be118ba3.svg";